import * as yup from 'yup';

export const branchReportSchema = yup.object({
  locationId: yup
    .mixed()
    .transform((value) => (value === '' ? undefined : value))
    .test('is-number', 'Branch is required', (value) => {
      if (value === undefined || value === '') return false;
      const num = Number(value);
      return !Number.isNaN(num) && num > 0 && Number.isInteger(num);
    })
    .required('Branch is required'),
});

export const categoryReportSchema = yup.object({
  categoryId: yup
    .mixed()
    .transform((value) => (value === '' ? undefined : value))
    .test('is-number', 'Category is required', (value) => {
      if (value === undefined || value === '') return false;
      const num = Number(value);
      return !Number.isNaN(num) && num > 0 && Number.isInteger(num);
    })
    .required('Category is required'),
});
export const staffReportSchema = yup.object({
  staffId: yup
    .mixed()
    .transform((value) => (value === '' ? undefined : value))
    .test('is-number', 'Staff is required', (value) => {
      if (value === undefined || value === '') return false;
      const num = Number(value);
      return !Number.isNaN(num) && num > 0 && Number.isInteger(num);
    })
    .required('Staff is required'),
});

